var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from 'react';
import { convertToNewFormStructure } from '@utils';
import classNames from 'classnames';
import DynamicForm from '../../widget/forms/DynamicForm/DynamicForm';
import Icon from '@icon/Icon';
import Button from '../../widget/buttons/Button';
import { UXPContext } from '../../core/context/Context';
const FormAlert = (props) => {
    let { id, title, content, onSubmit, onCancel, submitButtonTitle, cancelButtonTitle, remove, icon, formStructure, hideCancelButton } = props;
    if (!icon)
        icon = ['fas', 'file-alt'];
    const alertRef = React.useRef(null);
    const formRef = useRef(null);
    const context = React.useContext(UXPContext);
    const [submitting, setSubmitting] = React.useState(false);
    const handleRemove = () => {
        alertRef.current.classList.remove("uxpcore_alert--show");
        alertRef.current.classList.add("uxpcore_alert--hide");
        setTimeout(() => {
            remove(id);
        }, 300);
    };
    const submitLabel = submitButtonTitle || context.$L('uxp-core.text.submit');
    const cancelLabel = cancelButtonTitle || context.$L('uxp-core.text.cancel');
    const handleHeaderSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!formRef.current || submitting)
            return;
        setSubmitting(true);
        try {
            yield formRef.current.submit();
        }
        finally {
            setSubmitting(false);
        }
    });
    const handleHeaderCancel = () => {
        if (formRef.current)
            formRef.current.cancel();
        else {
            handleRemove();
            onCancel();
        }
    };
    // Keyboard shortcuts: Esc cancels, Enter submits. Tab cycles between fields/buttons natively.
    React.useEffect(() => {
        const handleKeyDown = (e) => {
            const target = e.target;
            if (e.key === 'Escape') {
                e.preventDefault();
                handleHeaderCancel();
                return;
            }
            if (e.key === 'Enter') {
                // Let native activation handle Enter on a focused button (incl. Cancel).
                if (target instanceof HTMLButtonElement)
                    return;
                // Don't hijack multi-line input.
                if (target instanceof HTMLTextAreaElement)
                    return;
                if (submitting)
                    return;
                // Intercept so DynamicForm's native <form> submit doesn't double-fire.
                e.preventDefault();
                handleHeaderSubmit();
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [submitting]);
    // Initial focus lands on the submit button so Enter activates the primary action.
    React.useEffect(() => {
        var _a;
        const btn = (_a = alertRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('button.uxpcore_alert__submit-btn');
        btn === null || btn === void 0 ? void 0 : btn.focus();
    }, []);
    return _jsxs("div", { className: classNames('uxpcore_alert', 'uxpcore_alert--form-alert', 'uxpcore_alert--show'), ref: alertRef, children: [_jsxs("div", { className: "uxpcore_alert__header", children: [_jsx("div", { className: "uxpcore_alert__title", children: typeof title == "string" ?
                            _jsxs("div", { className: "uxpcore_alert__title-content", children: [_jsx("div", { className: "uxpcore_alert__icon", children: _jsx(Icon, { icon: icon }) }), _jsx("div", { className: "uxpcore_alert__title-text", children: title })] })
                            : title() }), _jsxs("div", { className: "uxpcore_alert__header-actions", children: [!hideCancelButton && (_jsx(Button, { title: cancelLabel, onClick: handleHeaderCancel, variant: "secondary", type: "button", className: "uxpcore_alert__cancel-btn" })), _jsx(Button, { title: submitLabel, onClick: handleHeaderSubmit, loading: submitting, variant: "primary", type: "button", className: "uxpcore_alert__submit-btn" })] })] }), _jsxs("div", { className: "uxpcore_alert__body", children: [!!content &&
                        _jsx("div", { className: "instructions", children: typeof content == 'string' ? content : content() }), _jsx(DynamicForm, { ref: formRef, formStructure: convertToNewFormStructure(formStructure), onSubmit: (data) => __awaiter(void 0, void 0, void 0, function* () {
                            handleRemove();
                            onSubmit(data);
                        }), onCancel: () => {
                            handleRemove();
                            onCancel();
                        }, submitButtonLabel: submitButtonTitle, cancelButtonLabel: cancelButtonTitle, hideCancelButton: hideCancelButton, hideButtons: true })] })] }, id);
};
export default FormAlert;
